import { render } from "./PointOfSale.vue?vue&type=template&id=dff52d86&scoped=true"
import script from "./PointOfSale.vue?vue&type=script&lang=js"
export * from "./PointOfSale.vue?vue&type=script&lang=js"

import "./PointOfSale.vue?vue&type=style&index=0&id=dff52d86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dff52d86"]])

export default __exports__